import {app} from '../app';

class AuthenticationAccessPolicyResource {
    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getAuthenticationAccessPolicyList(companyId,info) {
        const url = `app/rest/company/${companyId}/policies/accesspolicies?info=${info}`;
        return this.$http.get(url).then(response => response.data);
    }

    createAuthenticationAccessPolicy(companyId) {
        const url = `app/rest/company/${companyId}/policies/accesspolicies`;
        return this.$http.post(url).then(response => response.data);
    }

    updateAuthenticationAccessPolicy(companyId, policy) {
        const url = `app/rest/company/${companyId}/policies/accesspolicies/${policy.id}`;
        return this.$http.put(url, policy).then(response => response.data);
    }

    deleteAuthenticationAccessPolicy(companyId, policyId) {
        const url = `app/rest/company/${companyId}/policies/accesspolicies/${policyId}`;
        return this.$http.delete(url).then(response => response.data);
    }

    reset(companyId, policyId) {
        const url = `app/rest/company/${companyId}/policies/accesspolicies/${policyId}`;
        const params = {action: 'reset'};
        return this.$http.put(url, null, {params}).then(response => response.data);
    }

    applyPolicy(companyId, policyId, appId) {
        const url = `app/rest/company/${companyId}/policies/accesspolicies/${policyId}/${appId}`;
        return this.$http.put(url).then(response => response.data);
    }
}

app.service('AuthenticationAccessPolicyResource', AuthenticationAccessPolicyResource);



// WEBPACK FOOTER //
// ./src/portal/rest/AuthenticationAccessPolicyResource.js